module.exports = __webpack_public_path__ + "media/post-listing-block-4-image.21863803.webp";